import React from "react";
import { withStyles } from "@material-ui/core";
import { getCurrentTerminalDateAndTime } from "../../utils";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 18,
  },
  titleContainer: {
    backgroundColor: theme.ModalBGColor,
  },
  logoContainer: {
    float: "right",
    padding: "5px",
    height: "20px",
  },
  title: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    paddingRight: 18,
    borderRight: `2px solid ${theme.AppBGColor}`,
  },
  returnShipment: {
    marginLeft: 18,
    paddingRight: 18,
    borderRight: `2px solid ${theme.AppBGColor}`,
  },
  date: {
    marginLeft: 18,
  },
});

const PrintHeader = ({ classes, totalReturnShipments, terminalOffset, terminalCode }) => {
  const currentDateAndTime = getCurrentTerminalDateAndTime(terminalOffset);
  return (
    <span className="onlyPrint">
      <div className={classes.container}>
        <span>
          <span className={classes.title}>Return Shipments</span>
          <span className={classes.returnShipment}>{totalReturnShipments} Total Returns</span>
          <span className={classes.returnShipment}>{terminalCode} Terminal</span>
          <span className={classes.date}>{currentDateAndTime}</span>
        </span>
        <img
          src="../../../../../../images/RouteMax_Logo_Print.svg"
          className={classes.logoContainer}
        />
      </div>
    </span>
  );
};

export default withStyles(styles)(PrintHeader);
